/**
 * DashboardRoute — variant gate for /dashboard.
 *
 * Delegates to `getUiVariant()` (frontend-only, see lib/uiVariant.js).
 * When variant === 'new' the redesigned Phase 2B dashboard renders;
 * otherwise the legacy pages/Dashboard.js renders unchanged.
 *
 * This file is the ONLY entry point for the /dashboard route in App.js.
 * The legacy Dashboard.js is NEVER edited by the Figma migration —
 * consistent with Amendment 11 (legacy shell freeze) and the Phase 2B
 * scope directive ("do not modify legacy application code").
 */
import React from 'react';
import DashboardLegacy from '@/pages/Dashboard';
import DashboardNew    from '@/pages/DashboardNew';
import { getUiVariant } from '@/lib/uiVariant';

export default function DashboardRoute() {
  const variant = getUiVariant();
  return variant === 'new' ? <DashboardNew /> : <DashboardLegacy />;
}
